export enum Product {
  Trial = "Trial",
  AdFree = "AdFree",
  Pro = "Pro",
  Enterprise = "Enterprise",
}

export enum Subscription {
  FreeSubscription = "Free subscription",
  TrialSubscription = "Trial subscription",
}

export enum PaymentLink {
  AdFree = "https://shop.bkash.com/bookkeeper01323867719/pay/bdt200/TLIw9Z",
  Pro = "https://shop.bkash.com/bookkeeper01323867719/pay/bdt100/SiLS4b",
  // ProYearly price represents the ProLifetime price
  ProYearly = "https://shop.bkash.com/bookkeeper01323867719/pay/bdt400/EY6ddQ",
  Enterprise = "https://shop.bkash.com/bookkeeper01323867719/pay/bdt500/zfusgV",
  EnterpriseYearly = "https://shop.bkash.com/bookkeeper01323867719/pay/bdt2000/6c0YBO",
}

export enum Caller {
  Subscription = "Subscription",
  Homepage = "Homepage",
}

/**
 * Firestore collections
 */
export enum Collection {
  Accounts = "accounts",
  Buyers = "buyers",
  Inventories = "inventories",
  Invoices = "invoices",
  InvoiceItems = "invoiceItems",
  Private = "private",
  Records = "records",
  RecordTypes = "recordTypes",
  Users = "users",
}

export enum Document {
  Profile = "profile",
}

/**
 * Firestore document fields
 */
export enum Field {
  Account = "account",
  AccountID = "accountId",
  Address = "address",
  Amount = "amount",
  BuyerID = "buyerId",
  Date = "date",
  Email = "email",
  InsertDate = "insertDate",
  Name = "name",
  Note = "note",
  Phone = "phone",
  Quantity = "quantity",
  TotalItems = "totalItems",
  TotalPrice = "totalPrice",
  UnitPrice = "unitPrice",
}

export enum InvoicePaymentType {
  DRAFT,
  PAID,
  UNPAID,
  UNKNOWN,
}

export enum StorageKey {
  AccessToken = "accessToken",
}

export enum AmountType {
  Credit = "credit",
  Debit = "debit",
}

export enum Route {
  BusinessProfile = "/business-profile",
  BuyerList = "/buyer-list",
  Dashboard = "/dashboard",
  InventoryList = "/inventory-list",
  InvoiceList = "/invoice-list",
  PrivacyPolicy = "/privacy-policy",
  RecordList = "/record-list",
  Subscription = "/subscription",
}

export enum DateLocale {
  Bengali = "bn-BD",
  English = "en-US",
}

export enum Filters {
  WEEK = "WEEK",
  MONTH = "MONTH",
  LAST_MONTH = "LAST_MONTH",
  YEAR = "YEAR",
  CUSTOM = "CUSTOM",
}
